import {
  createSchoolTicketAsync,
  deleteSchoolTicketAsync,
  getAllSchoolTicketByLicenseAsync,
  getSchoolTicketByIdAsync,
  updateSchoolTicketAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSchoolTicketAsync = () =>
  useMutation(createSchoolTicketAsync);

export const useGetSchoolTicketByIdAsync = () =>
  useMutation(getSchoolTicketByIdAsync);

export const useGetAllSchoolTicketByLicenseAsync = () =>
  useMutation(getAllSchoolTicketByLicenseAsync);

export const useUpdateSchoolTicketAsync = () =>
  useMutation(updateSchoolTicketAsync);

export const useDeleteSchoolTicketAsync = () =>
  useMutation(deleteSchoolTicketAsync);
